import { render, staticRenderFns } from "./CsiTranslationsItemListPage.vue?vue&type=template&id=c85fc00a&"
import script from "./CsiTranslationsItemListPage.vue?vue&type=script&lang=ts&"
export * from "./CsiTranslationsItemListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports